import { TRACK_PERCENTAGE, TRACK_SECONDS } from '~/Share/constants';

export const isVideoFile = (f: File | null) =>
  f != null && f.type.match(/^(video|application\/octet-stream)\/.*$/g);

export const stopAllVideo = () => {
  const videos = document.getElementsByTagName('video');

  for (const video of videos) {
    if (video.paused) video.pause();
  }
};

export const isVideoWatched = (video: HTMLVideoElement) => {
  const time = video.currentTime;
  const total = video.duration;
  const progress = (time / total) * 100;

  return progress > TRACK_PERCENTAGE || time > TRACK_SECONDS;
};

export enum VideoFormat {
  Mp4 = 'video/mp4',
  Webm = 'video/webm',
  Mov = 'video/quicktime',
}

export const acceptedVideoFormats = Object.values(VideoFormat);

export const isValidVideoFormat = (file: File) => {
  return acceptedVideoFormats.includes(file.type as VideoFormat);
};
